import { gql } from 'graphql-request'

export const VERIFY_AGE = gql`
  mutation VerifyAge($verifyAgeInput: UserAgeVerifyInput!) {
    verifyAge(verifyAgeInput: $verifyAgeInput) {
      id
    }
  }
`
